import type { Facts, FactKey, Me } from "./types";

/** Offline mode: `?mock=1`, or the page opened straight off the filesystem. */
export const MOCK =
  location.protocol === "file:" ||
  new URLSearchParams(location.search).has("mock");

export const CARD_QUESTIONS: Record<FactKey, string> = {
  leave: "How many days of annual leave do I have left?",
  mc: "How many MC days have I used this year?",
  payslip: "When is my next payslip and how much will it be?",
};

// Byte-for-byte the sentences the employee-self-service pipeline computes
// server-side (employee_selfservice.py::format_answer) — mock mirrors real.
export const MOCK_ANSWERS: Facts = {
  leave: "You have 12.5 days of annual leave remaining.",
  mc: "You have used 2 MC days so far this year.",
  payslip: "Your next payslip is estimated at S$4,800.00 gross, on 1 August 2026.",
};

export const MOCK_ME: Me = {
  email: "marcus.lee@harbourview.example",
  company_id: "harbourview",
  employee_slug: "marcus-lee",
  display_name: "Marcus Lee",
  org_name: "Harbourview Logistics Pte Ltd",
  source: "employment_hero",
  synced_at: new Date(Date.now() - 9 * 60 * 1000).toISOString(),
  claim_style: "flat",
};

export const MOCK_S_PASS_ANSWER =
  "New S Pass applications require a minimum qualifying salary of S$3,300 per month, and it rises with the candidate's age. The financial services sector has a higher floor of S$3,800.\n\nFigures are based on ingested MOM resources — verify current values at mom.gov.sg before acting.";

export const MOCK_FALLBACK_ANSWER =
  "Here is what I found in your records and the company handbook. (Mock mode — start serve.mjs for live answers.)";

export const MOCK_TG_CODE = {
  code: "mock0000mock0000mock0000mock0000",
  bot: "WorkJoyHRBot",
  url: "https://t.me/WorkJoyHRBot?start=mock0000mock0000mock0000mock0000",
  expires_in: 600,
};

export const MOCK_SIGNIN_MESSAGE =
  "If that address is in your company directory, a sign-in link is on its way. Check your inbox.";
